export const TICKET = "TICKET";
export const TICKET_SUCCESS = "TICKET_SUCCESS";
export const TICKET_FAILED = "TICKET_FAILED";

export const ADD_TICKET = "ADD_TICKET";
export const ADD_TICKET_SUCCESS = "ADD_TICKET_SUCCESS";
export const ADD_TICKET_FAILED = "ADD_TICKET_FAILED";

export const UPDATE_TICKET = "UPDATE_TICKET";
export const UPDATE_TICKET_SUCCESS = "UPDATE_TICKET_SUCCESS";
export const UPDATE_TICKET_FAILED = "UPDATE_TICKET_FAILED";